import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class StudentAccount extends Api {
    constructor(http, config = {}) {
        super(http, url, 'studentAccount', config);
    }

    postDirectDebit(bodyRequest){
        return this._http.post(`${this._baseUrl}/studentAccount/direct-debit`, bodyRequest)
    }

    postRefinance(careerId, bodyRequest){
        return this._http.post(`${this._baseUrl}/studentAccount/${careerId}/refinance`, bodyRequest)
    }

    hasFirstPayment(studentId) {
        return this._http.get(`${this._baseUrl}/studentAccount/${studentId}`);
    }
}
